import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import { AuthApi, ApplicationApi } from "services/index";
import { GlobalErrorHandler } from "utils/globalErrorHandler";
import { RequestsApi } from "../../services/requests.api";
import { NotificationsApi } from "services/notifications.api";
import { MessageApi } from "../../services/message.api";
import { DashboardApi } from "../../services/dashboard.api";
import { TeamStatisticsApi } from "../../services/teamStatistics.api";
import { TeamOverlapApi } from "../../services/teamOverlap.api";
import { TeamLeaveHeatmapApi } from "../../services/teamLeaveHeatmap.api";
import { PublicCalendarApi } from "../../services/publicCalendar.api";
import { employeeActionApi } from "../../services/employeeAction.api";
import { MeetingApi } from "../../services/meeting.api";
import { AnnouncementApi } from "../../services/announcement.api";
import { SurveyApi } from "../../services/survey.api";
import { AttendanceApi } from "../../services/attendance.api";
import { TrainingApi } from "../../services/training.api";
import { AdminUserApi } from "../../services/adminUser.api";

export const rtkQueryErrorLogger =
  (api: any) => (next: any) => (action: any) => {
    if (isRejectedWithValue(action)) {
      GlobalErrorHandler(action.payload);
    }
    return next(action);
  };

const rootReducer = combineReducers({
  [AuthApi.reducerPath]: AuthApi.reducer,
  [ApplicationApi.reducerPath]: ApplicationApi.reducer,
  [RequestsApi.reducerPath]: RequestsApi.reducer,
  [NotificationsApi.reducerPath]: NotificationsApi.reducer,
  [MessageApi.reducerPath]: MessageApi.reducer,
  [DashboardApi.reducerPath]: DashboardApi.reducer,
  [TeamStatisticsApi.reducerPath]: TeamStatisticsApi.reducer,
  [TeamOverlapApi.reducerPath]: TeamOverlapApi.reducer,
  [TeamLeaveHeatmapApi.reducerPath]: TeamLeaveHeatmapApi.reducer,
  [PublicCalendarApi.reducerPath]: PublicCalendarApi.reducer,
  [employeeActionApi.reducerPath]: employeeActionApi.reducer,
  [MeetingApi.reducerPath]: MeetingApi.reducer,
  [AnnouncementApi.reducerPath]: AnnouncementApi.reducer,
  [SurveyApi.reducerPath]: SurveyApi.reducer,
  [AttendanceApi.reducerPath]: AttendanceApi.reducer,
  [TrainingApi.reducerPath]: TrainingApi.reducer,
  [AdminUserApi.reducerPath]: AdminUserApi.reducer,
});
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(AuthApi.middleware)
      .concat(ApplicationApi.middleware)
      .concat(RequestsApi.middleware)
      .concat(NotificationsApi.middleware)
      .concat(MessageApi.middleware)
      .concat(DashboardApi.middleware)
      .concat(TeamStatisticsApi.middleware)
      .concat(TeamOverlapApi.middleware)
      .concat(TeamLeaveHeatmapApi.middleware)
      .concat(PublicCalendarApi.middleware)
      .concat(employeeActionApi.middleware)
      .concat(MeetingApi.middleware)
      .concat(AnnouncementApi.middleware)
      .concat(SurveyApi.middleware)
      .concat(AttendanceApi.middleware)
      .concat(TrainingApi.middleware)
      .concat(AdminUserApi.middleware)
      .concat(rtkQueryErrorLogger),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
